import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/h5/story.png'


const _withScopeId = n => (_pushScopeId("data-v-60d0ce84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "singleStory" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"img-area\" data-v-60d0ce84><img src=\"" + _imports_0 + "\" data-v-60d0ce84><div class=\"text-area\" data-v-60d0ce84><div class=\"name\" data-v-60d0ce84>员工故事</div><div class=\"desc\" data-v-60d0ce84>Employee Story</div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_story = _resolveComponent("story")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_tabs, {
      active: _ctx.activeName,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
      onClickTab: _ctx.handleClick,
      "title-active-color": "#3693FF",
      color: "#3693FF"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, {
          title: "社招员工",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_story, {
              recruitingType: 1,
              isSingle: true
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, {
          title: "校招员工",
          name: "2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_story, {
              recruitingType: 2,
              isSingle: true
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active", "onClickTab"])
  ]))
}